let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3hbva")).then(() => parcelRequire('9YR8M'));